import React from 'react';
import { useFrontload } from 'react-frontload';
import { useDispatch } from 'react-redux';
import { fetchVideo } from '../../redux/videos';
import { VideoDetail } from './video_detail';

interface OwnProps {
  uid: string;
}

export const VideoDetailContainer = (props: OwnProps) => {
  const { uid } = props;
  const dispatch = useDispatch();

  useFrontload(`VideoDetailContainer_${uid}`, async () => {
    await dispatch(fetchVideo(uid));

    return true;
  });

  return <VideoDetail uid={uid} />;
};
